import { combineReducers } from "@reduxjs/toolkit";
import groupsReducer from "./groupsSlice";
import studiosReducer from "./studiosSlice";
import subjectsReducer from "./subjectsSlice";
import studentsReducer from "./studentsSlice";
import parentsReducer from "./parentsSlice";
import employeesReducer from "./employeesSlice";


const dictsReducer = combineReducers({
    groups: groupsReducer,
    studios: studiosReducer,
    subjects: subjectsReducer,
    students: studentsReducer,
    parents: parentsReducer,
    employees: employeesReducer,
})

export default dictsReducer